import { render, staticRenderFns } from "./BaseTagsInput.vue?vue&type=template&id=047b5d2a"
import script from "./BaseTagsInput.vue?vue&type=script&lang=js"
export * from "./BaseTagsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports